import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService } from 'src/app/_services/campaign.service';
import { ICampaign, ICampaignStage } from 'src/app/model/campaign';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-create-campaign-zero',
  templateUrl: './create-campaign-zero.component.html',
  styleUrls: ['./create-campaign-zero.component.scss']
})
export class CreateCampaignZeroComponent implements OnInit {
  campaign_id: number;
  campaign_details: Partial<ICampaign> = {};
  isLoaded: boolean = false;
  availableStages: ICampaignStage[] = [];
  isInEditMode:  {stageId, editMode} = {stageId: null, editMode: false};
  errorMessage: string='';
  
  activatedStage: ICampaignStage;
  prevStageId: number;
  userid: number;

  get canEditStage() {
    return this.campaign_details && this.campaign_details.status != 1 && this.campaign_details.status != 2;
  }

  constructor(private router: Router, private route: ActivatedRoute, private campaignService: CampaignService, private localStorageService: LocalStorageService) { 
    //convert string to number
    this.campaign_id = +this.route.snapshot.paramMap.get('campaign_id');
    this.userid = this.localStorageService.getItem('userdata').userid

  }

  ngOnInit() {
    this.campaignService.getCampaignDetails(this.campaign_id).subscribe(
      (result) => {
        if(result['data'].created_by!==this.userid){
          this.router.navigate(['email-campaign/campaign-listing'])
          return;
        }
        this.campaign_details = result['data'];
      }
    )
    this.getCampaignStages();
  }
  redirectToCreateCampaign(){
    if(this.campaign_details && this.campaign_details['status'] === 3){
      this.router.navigate(['email-campaign/campaign-listing']);
    }
    else if(this.availableStages && this.availableStages.length){
      this.router.navigate(['email-campaign/target-listing/'+this.campaign_id])
    }
    else
      this.router.navigate(['email-campaign/campaign-listing'])
  } 
 

  getCampaignStages(){
    this.campaignService.getStages(this.campaign_id).subscribe((res: any) => {
      if(res.status=='success'){
        this.availableStages = res.data.map(x=>{
          x.body = x.body.replace(/(<img src=\"{{tracker}}\">)/g, "").replace(/(<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe <\/a> <\/p>)/g, "");
          x.isUnsubscribed = x?.allow_unsubscription;
          return x;
        });
        this.isLoaded = true;
      }
      else{
        this.availableStages = [];
        console.error('failed to get Stages');
      }
    })
  }
  showErrorMessage(){
    this.errorMessage = "Please save all active stages to proceed";
    setTimeout(()=>{
      this.errorMessage = "";
    }, 2000)
  }

  setEditPanelData(stage: ICampaignStage) {
    this.activatedStage = stage;

    //store previous campaign_stage_id from availablestages in prevStageId if activated stage is availableStages[0] store null in prevStageId
    if(this.availableStages && this.availableStages.length && this.activatedStage && this.activatedStage.campaign_stage_id && this.availableStages[0].campaign_stage_id == this.activatedStage.campaign_stage_id){
      this.prevStageId = null;
    }
    else{
      //store campaignStageId at prev index
      this.prevStageId = this.availableStages && this.availableStages.length ? this.availableStages[this.availableStages.indexOf(stage)-1]?.campaign_stage_id : null;
    }

  }
  setIsEditMode(editState: {stageId, editMode}) {
    this.isInEditMode = editState;
  }
  updateStageValue(event: ICampaignStage){
    this.activatedStage = event;
    this.availableStages = this.availableStages.map(x=>{
      if(x.campaign_stage_id==event.campaign_stage_id || x.campaign_stage_id==null){ 
        x.isUnsubscribed = x?.allow_unsubscription;
        event.body = event.body.replace(/(<img src=\"{{tracker}}\">)/g, "").replace(/(<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe <\/a> <\/p>)/g, ""); 
        return event;
      } else return x;
    })
  }
  addNewStage(event: number){
    if(event>0){
      this.availableStages = this.availableStages.concat([{
        ...this.availableStages[event-1],
        stage_name:`Follow up email - ${event}`,
        campaign_stage_id : null,
        after_id: this.availableStages[event-1].campaign_stage_id,
        body: null,
        subject: null,
        after_minutes: null,
        regular_days: false,
        isUnsubscribed: true
      }]);
      // this.isInEditMode = {stageId: null, editMode: true};
      this.setEditPanelData(this.availableStages[event])
      this.isInEditMode = {stageId: this.activatedStage.campaign_stage_id, editMode: true};
    }
    else if(event==0){

      this.availableStages = [];
      this.activatedStage = null;
      this.availableStages.pop();
      this.availableStages.push({
        stage_name:`First Email - ${1}`,
        campaign_stage_id : null,
        after_id: null,
        body: null,
        subject: "",
        after_minutes: null,
        regular_days: false,
        campaign_id: null,
        created_by: null,
        is_active: null,
        created_on: null,
        updated_on: null,
        isUnsubscribed: true        
      });
      this.setEditPanelData(this.availableStages[0]);
      this.isInEditMode = {stageId: null, editMode: true};
    }
    else if(event==-2){
      /**
       * Deleted existing stage 
       */
      this.getCampaignStages();
    }
    else{
      this.availableStages = this.availableStages.map(x=>x);
      this.availableStages.pop();
      this.setEditPanelData(this.availableStages[this.availableStages.length + event]);
      this.isInEditMode = {stageId: this.activatedStage.campaign_stage_id, editMode: false};
    }
  }
  updateCampaignDetails(event: ICampaign){
    this.campaign_details = {
      ...this.campaign_details,
      ...event
    }
  }

}
